// https://firebase.google.com/docs/cloud-messaging/js/client#web-modular-api
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAAxfhqhGTGJoyCF1OWfwOJqYQtjsKBbgg',
  authDomain: 'sellergeni-production.firebaseapp.com',
  projectId: 'sellergeni-production',
  storageBucket: 'sellergeni-production.appspot.com',
  messagingSenderId: '576313653223',
  appId: '1:576313653223:web:5f0823603f32384693af42',
  measurementId: 'G-ZZ6LJKHXXV',
};

// Initialize Firebase
export const firebase = initializeApp(firebaseConfig);
export const firebaseMessaging = getMessaging(firebase);
